var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "forgotPassword", attrs: { id: "forgot-password-app" } },
    [
      _c("div", { staticClass: "passwordContainer" }, [
        _c("img", {
          staticClass: "logo",
          attrs: {
            src: _vm.darkMode
              ? _vm.brandingService.getLoginDarkLogoUrl()
              : _vm.brandingService.getLoginLogoUrl(),
            alt: "brandingService.getLoginLogoAlt()",
          },
        }),
        _vm._v(" "),
        !_vm.submitted
          ? _c(
              "section",
              { staticClass: "middle form" },
              [
                _c("h1", [_vm._v("Forgot Password")]),
                _vm._v(" "),
                _c("p", { staticClass: "instructions" }, [
                  _vm._v(
                    "Enter your username to reset your password. You may need to check your spam folder for emails from noreply@wxpcollaboration.hp.com."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "v-form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                    model: {
                      value: _vm.allFieldsValid,
                      callback: function ($$v) {
                        _vm.allFieldsValid = $$v
                      },
                      expression: "allFieldsValid",
                    },
                  },
                  [
                    _c("v-text-field", {
                      staticClass: "email",
                      attrs: {
                        rules: [_vm.rules.required, _vm.rules.formatEmail],
                        solo: "",
                        flat: "",
                        outlined: "",
                        dense: "",
                        label: "Username",
                      },
                      model: {
                        value: _vm.userEmail,
                        callback: function ($$v) {
                          _vm.userEmail = $$v
                        },
                        expression: "userEmail",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary submit",
                        attrs: {
                          onsubmit: "false",
                          disabled: !_vm.allFieldsValid,
                        },
                        on: { click: _vm.submitEmail },
                      },
                      [_vm._v("Submit")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.submitted
          ? _c("section", { staticClass: "middle submitted" }, [
              _c("h1", [_vm._v("Check Your Email")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "WXP Collaboration will send you an email with a link to reset your password."
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "copywrite" }, [
          _vm._v("© " + _vm._s(_vm.currentYear) + " HP Inc. "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.hp.com/us-en/privacy/privacy-central.html",
                target: "_blank",
              },
            },
            [_vm._v("Privacy Statement")]
          ),
          _vm._v(",\n      "),
          _c(
            "a",
            {
              attrs: {
                href: "https://support.hp.com/us-en/document/ish_12775809-12775790-16",
                target: "_blank",
              },
            },
            [_vm._v("EULA")]
          ),
          _vm._v(",\n      and "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf",
                target: "_blank",
              },
            },
            [_vm._v("DPA")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }